import { usePage } from "PFApp/use_page";
import { fetchAccount, removeAccount } from "PFCore/services/accounts/account";
import { Account } from "PFTypes/account";
import { useEffect } from "react";

type InitPage = {
  account: Account | null;
  fetch: Function | null;
  loaded: boolean;
  errors: string[];
};

const initPage: InitPage = { account: null, fetch: null, loaded: false, errors: [] };

export const useDestroyAccountPage = (accountId: string) => {
  const { page, setPage, mergePage, resetPage } = usePage<InitPage>(`edit_account`, initPage);

  const fetch = () => {
    if (accountId === undefined || accountId === null) {
      return mergePage({
        loaded: true
      });
    }

    return fetchAccount(accountId)
      .then((response) =>
        mergePage({
          loaded: true,
          account: response
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          account: null
        })
      );
  };

  const deleteAccount = () =>
    removeAccount(accountId).catch(() => {
      mergePage({
        errors: ["There was an error"]
      });
    });

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    fetch();
  }, []);

  return { ...page, deleteAccount };
};
